import type { JSX } from "react";

export type Phase =
  | "new"
  | "waxing-crescent"
  | "first-quarter"
  | "waxing-gibbous"
  | "full"
  | "waning-gibbous"
  | "last-quarter"
  | "waning-crescent";

const phases: Record<Phase, JSX.Element> = {
  "new": (
    <circle cx="6" cy="6" r="5" fill="none" stroke="currentColor" strokeWidth="0.8" />
  ),
  "waxing-crescent": (
    <>
      <circle cx="6" cy="6" r="5" fill="none" stroke="currentColor" strokeWidth="0.6" />
      <path d="M6 1 A 5 5 0 0 1 6 11 A 3 5 0 0 0 6 1" fill="currentColor" />
    </>
  ),
  "first-quarter": (
    <>
      <circle cx="6" cy="6" r="5" fill="none" stroke="currentColor" strokeWidth="0.6" />
      <path d="M6 1 A 5 5 0 0 1 6 11 Z" fill="currentColor" />
    </>
  ),
  "waxing-gibbous": (
    <>
      <circle cx="6" cy="6" r="5" fill="none" stroke="currentColor" strokeWidth="0.6" />
      <path d="M6 1 A 5 5 0 0 1 6 11 A 4.5 5 0 0 1 6 1" fill="currentColor" />
    </>
  ),
  "full": <circle cx="6" cy="6" r="5" fill="currentColor" />,
  "waning-gibbous": (
    <>
      <circle cx="6" cy="6" r="5" fill="none" stroke="currentColor" strokeWidth="0.6" />
      <path d="M6 1 A 5 5 0 0 0 6 11 A 4.5 5 0 0 0 6 1" fill="currentColor" />
    </>
  ),
  "last-quarter": (
    <>
      <circle cx="6" cy="6" r="5" fill="none" stroke="currentColor" strokeWidth="0.6" />
      <path d="M6 1 A 5 5 0 0 0 6 11 Z" fill="currentColor" />
    </>
  ),
  "waning-crescent": (
    <>
      <circle cx="6" cy="6" r="5" fill="none" stroke="currentColor" strokeWidth="0.6" />
      <path d="M6 1 A 5 5 0 0 0 6 11 A 3 5 0 0 1 6 1" fill="currentColor" />
    </>
  ),
};

export function Moon({ phase = "full" }: { phase?: Phase }) {
  return (
    <svg className="moon" viewBox="0 0 12 12" width="11" height="11">
      {phases[phase]}
    </svg>
  );
}

// Reference: synodic month ≈ 29.53d, new moon Jan 6 2026.
export function moonPhase(date: Date): Phase {
  const ref = new Date(2026, 0, 6).getTime();
  const days = (date.getTime() - ref) / 86_400_000;
  const phase = ((days % 29.53) + 29.53) % 29.53;
  if (phase < 1.85) return "new";
  if (phase < 5.54) return "waxing-crescent";
  if (phase < 9.23) return "first-quarter";
  if (phase < 12.91) return "waxing-gibbous";
  if (phase < 16.61) return "full";
  if (phase < 20.30) return "waning-gibbous";
  if (phase < 23.99) return "last-quarter";
  if (phase < 27.68) return "waning-crescent";
  return "new";
}
